import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classNames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import property from 'lodash/property';
import { Box, Text } from '@nerdwallet/currency';
import styles from './back-to-top.module.less';
import { stringInputSpec, stringSelectSpec } from '../../lib/editing-configs';

let currentWindow = null;
const scrollingPageValue = 75; // how much the page was scrolled

const BackToTop = ({ alternateIconUrl, displayDevices, size }) => {
  const [show, setShow] = useState(false);

  const handleOnScroll = useCallback((e) => {
    if (e.target.scrollingElement.scrollTop > scrollingPageValue) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    currentWindow = window;
    currentWindow.addEventListener('scroll', handleOnScroll);
    return () => {
      if (currentWindow) {
        currentWindow.removeEventListener('scroll', handleOnScroll);
      }
    };
  }, [handleOnScroll]);

  const handleScrollToTop = () => {
    if (currentWindow) {
      currentWindow.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (
    displayDevices === 'all' ||
    displayDevices === size ||
    (displayDevices === 'sm' && size === 'md') // let's consider 'md' as mobile
  ) {
    return (
      <Box
        onClick={handleScrollToTop}
        style={{
          backgroundImage: `url(${alternateIconUrl || null})`,
        }}
        className={classNames(styles.container, [
          {
            [styles.visible]: show,
            [styles.alternateIcon]: alternateIconUrl,
          },
        ])}
      >
        <Text align="center">Back to Top</Text>
      </Box>
    );
  }

  return null;
};

BackToTop.displayName = 'Back to Top';

BackToTop.propTypes = {
  alternateIconUrl: PropTypes.string,
  displayDevices: PropTypes.oneOf(['all', 'lg', 'sm']),
  size: PropTypes.string,
};

BackToTop.defaultProps = {
  alternateIconUrl: '',
  displayDevices: 'all',
  size: '',
};

BackToTop.getEditingConfig = () => {
  return [
    stringSelectSpec(
      'displayDevices',
      'Display Devices',
      [
        {
          value: 'all',
          label: 'Desktop and Mobile',
        },
        {
          value: 'lg',
          label: 'Desktop Only',
        },
        {
          value: 'sm',
          label: 'Mobile Only',
        },
      ],
      {
        help: "Which devices backToTop will be displayed? Default to 'All'",
      }
    ),
    stringInputSpec('alternateIconUrl', 'Alternate back to top icon URL'),
  ];
};

export default connect(
  createStructuredSelector({
    size: property('mediaQuery'),
  })
)(BackToTop);
